import authService from 'core/services/auth';

interface AuthActionProps {
	action: string;
	children: any;
}

function AuthActionComponent({ action, children }: AuthActionProps) {
	return authService.getRoles().findIndex((el) => el.name === 'super_admin') >= 0
		? children
		: authService.isPermittedToAction(action)
		? children
		: null;
}

export default AuthActionComponent;
